/**
 * ─────────────────────────────────────────────────────────────────
 *  BASE URL — the ONE place that decides where API calls go.
 *  Every API call in the entire app reads from here.
 * ─────────────────────────────────────────────────────────────────
 *
 *  ONE-CLICK MODE SWITCH
 *  ─────────────────────
 *  Set MODE below:
 *    'auto'  → detect from the hostname (recommended; works everywhere)
 *    'local' → force local dev  (http://localhost:5000)
 *    'liara' → force production (same-origin, e.g. https://nowshin.ir)
 *
 *  In production the Node server serves BOTH the API and the React app on the
 *  same domain, so the API base is RELATIVE ('') → calls go to the current
 *  origin. That means every restaurant subdomain (yasmin.nowshin.ir) talks to
 *  its own origin automatically — nothing else to configure.
 */
const MODE = 'auto'; // 'auto' | 'local' | 'liara'

const LOCAL_URL = 'http://localhost:5000';

function detect() {
  if (MODE === 'local') return LOCAL_URL;
  if (MODE === 'liara') return '';                       // same-origin
  // auto: localhost (any subdomain) → local server; anything else → same-origin
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h.endsWith('.localhost') || h === '127.0.0.1') return LOCAL_URL;
  }
  return ''; // production / deployed → relative, same-origin
}

/** Base origin for the server. '' means same-origin (production). */
export const BASE_URL = detect();

/** Full API prefix used by every call in apiClient.js */
export const API = `${BASE_URL}/api`;
